import { createContext } from 'react';

export type ThemeMode = 'dark' | 'light';

export interface ThemeContextValue {
  mode: ThemeMode;
  toggleTheme: () => void;
}

// 단일 ThemeContext 인스턴스. App.tsx 의 <ThemeContext.Provider> 가 이 객체를 사용해
// 모든 소비자(현장 페이지 / 위젯)와 같은 컨텍스트를 공유한다.
// App.tsx 도 호환을 위해 이 모듈을 import 한 뒤 다시 export 한다 (단방향).
export const ThemeContext = createContext<ThemeContextValue>({
  mode: 'dark',
  toggleTheme: () => {
    /* default no-op; the real toggle is provided by App.tsx */
  },
});
